import React, { useState } from "react";
import { connect } from "react-redux";
import Video from "./Video";

const videos = [
  // Torah & Pentateuch
  {
    name: "The Torah Explained",
    url: "https://www.youtube.com/embed/ALsluAKBZ-c",
    category: "Torah & Foundation",
    description: "Understanding the five books of Moses and their significance"
  },
  {
    name: "Genesis Overview",
    url: "https://www.youtube.com/embed/l4TB-QKpotI?si=BJeUtP0h9H-Xk0SC",
    category: "Torah & Foundation",
    description: "Creation, fall, and the patriarchs"
  },
  {
    name: "Exodus Overview",
    url: "https://www.youtube.com/embed/jH_aojNJM3E",
    category: "Torah & Foundation",
    description: "Deliverance from Egypt and the covenant at Sinai"
  },
  
  // Gospel & New Testament
  {
    name: "Matthew Overview",
    url: "https://www.youtube.com/embed/3Dv4-n6OYGI",
    category: "Gospels",
    description: "Jesus as the Messiah and King"
  },
  {
    name: "Mark Overview",
    url: "https://www.youtube.com/embed/HGHqu9-DtXk",
    category: "Gospels",
    description: "Jesus as the suffering servant"
  },
  {
    name: "Luke Overview",
    url: "https://www.youtube.com/embed/26z_KhwNdD8",
    category: "Gospels",
    description: "Jesus as the Savior of all people"
  },
  {
    name: "John Overview",
    url: "https://www.youtube.com/embed/G-2e9mMf7E8",
    category: "Gospels",
    description: "Jesus as the Son of God"
  },
  
  // Core Biblical Themes
  {
    name: "The Bible's Big Story",
    url: "https://www.youtube.com/embed/7_CGP-12AE0",
    category: "Biblical Themes",
    description: "Understanding the overarching narrative of Scripture"
  },
  {
    name: "Covenants",
    url: "https://www.youtube.com/embed/xvvey71pfy0?si=94Ayad_tyyF0n46-",
    category: "Biblical Themes",
    description: "God's promises throughout Scripture"
  },
  {
    name: "The Messiah",
    url: "https://www.youtube.com/embed/3dEh25pduQ8",
    category: "Biblical Themes",
    description: "Understanding Jesus in the biblical narrative"
  },
  {
    name: "The Kingdom of God",
    url: "https://www.youtube.com/embed/xmFPS0f-kzs",
    category: "Biblical Themes",
    description: "God's reign and rule through history"
  },
  
  // Old Testament Books
  {
    name: "Psalms Overview",
    url: "https://www.youtube.com/embed/j9phNEaPrv8",
    category: "Wisdom & Poetry",
    description: "Israel's songbook and prayer book"
  },
  {
    name: "Proverbs Overview",
    url: "https://www.youtube.com/embed/AzmYV8GNAIM",
    category: "Wisdom & Poetry",
    description: "Wisdom for daily living"
  },
  {
    name: "Isaiah Overview",
    url: "https://www.youtube.com/embed/4jfKdCEGwF0?si=jA3b-vgkWAOF_M9G",
    category: "Prophets",
    description: "Judgment and hope through the prophet Isaiah"
  },
  
  // New Testament Teaching
  {
    name: "Romans Road",
    url: "https://www.youtube.com/embed/K9wSOwMYAhA?si=4rGDvo3TxUTvNw2L",
    category: "Epistles",
    description: "The gospel and righteousness through faith"
  },
  {
    name: "Romans 5-8",
    url: "https://www.youtube.com/embed/0SVTl4Xa5fY",
    category: "Epistles",
    description: "Life in the Spirit"
  },
  {
    name: "Ephesians Overview",
    url: "https://www.youtube.com/embed/Y71r-T98E2Q",
    category: "Epistles",
    description: "The church and spiritual blessings in Christ"
  },
  
  // Biblical Concepts
  {
    name: "Holiness",
    url: "https://www.youtube.com/embed/l9vn5UvsHvM",
    category: "Core Concepts",
    description: "Understanding God's holiness and its implications"
  },
  {
    name: "Justice",
    url: "https://www.youtube.com/embed/A14THPoc4-4",
    category: "Core Concepts",
    description: "Biblical justice and righteousness"
  },
  {
    name: "Sacrifice and Atonement",
    url: "https://www.youtube.com/embed/G_OlRWGLdnw",
    category: "Core Concepts",
    description: "The sacrificial system and Jesus' sacrifice"
  }
];

const categories = [
  "All",
  "Torah & Foundation",
  "Gospels",
  "Biblical Themes",
  "Wisdom & Poetry",
  "Prophets",
  "Epistles",
  "Core Concepts"
];

function Videos(props) {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");

  const filteredVideos = videos.filter(video => {
    const matchesCategory = selectedCategory === "All" || video.category === selectedCategory;
    const matchesSearch = video.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         video.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <br />
      <h2 style={{ textAlign: "center", marginBottom: "10px" }}>Video Teachings</h2>
      <p style={{ textAlign: "center", color: "#666", marginBottom: "30px", fontSize: "16px" }}>
        Explore foundational biblical sections, books, and concepts
      </p>

      {/* Search Bar */}
      <div style={{ marginBottom: "20px", width: '80%', margin: '0 auto' }}>
        <input
          type="text"
          placeholder="Search videos..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "10px 15px",
            fontSize: "16px",
            border: "1px solid #ddd",
            borderRadius: "5px"
          }}
        />
      </div>

      {/* Category Filter */}
      <div style={{ 
        marginBottom: "30px", 
        display: "flex", 
        flexWrap: "wrap", 
        gap: "10px",
        justifyContent: "center"
      }}>
        {categories.map(category => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            style={{
              padding: "8px 16px",
              fontSize: "14px",
              border: "1px solid #ddd",
              borderRadius: "20px",
              backgroundColor: selectedCategory === category ? "#007bff" : "#fff",
              color: selectedCategory === category ? "#fff" : "#333",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Video Count */}
      <p style={{ textAlign: "center", color: "#666", marginBottom: "20px", fontSize: "16px" }}>
        Showing {filteredVideos.length} video{filteredVideos.length !== 1 ? 's' : ''}
      </p>

      {/* Videos Grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: "30px",
        marginTop: "20px"
      }}>
        {filteredVideos.map((video, index) => (
          <div key={index} style={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            padding: "15px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}>
            <div style={{
              fontSize: "16px",
              color: "#007bff",
              fontWeight: "600",
              marginBottom: "8px",
              textTransform: "uppercase"
            }}>
              {video.category}
            </div>
            <h3 style={{ marginBottom: "8px", fontSize: "18px" }}>{video.name}</h3>
            <p style={{ 
              fontSize: "16px", 
              color: "#666", 
              marginBottom: "15px",
              lineHeight: "1.4"
            }}>
              {video.description}
            </p>
            <Video name={video.name} url={video.url} />
          </div>
        ))}
      </div>

      {filteredVideos.length === 0 && (
        <p style={{ textAlign: "center", color: "#999", marginTop: "40px" }}>
          No videos found matching your search.
        </p>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
    profile_pic_url: state.profile_pic_url,
    profile_pic_alt: state.profile_pic_alt,
  };
};

export default connect(mapStateToProps, {})(Videos);